import { Member } from '@wix/ambassador-members-ng-api/types';
import { ContactDetails } from '../../types/ambassador/bookings/ambassador-bookings-v2-booking';

export const getMemberEmail = (memberDetails?: Member) =>
  memberDetails?.loginEmail || memberDetails?.contact?.emails?.[0];

const mapMemberToContactDetails = (memberDetails?: Member): ContactDetails => ({
  email: getMemberEmail(memberDetails),
  firstName: memberDetails?.contact?.firstName,
  lastName: memberDetails?.contact?.lastName,
  phone: memberDetails?.contact?.phones?.[0],
  contactId: memberDetails?.contactId,
});

export const getPayerContactDetails = ({
  isBookingForSomeoneElse,
  contactDetails,
  memberDetails,
}: {
  isBookingForSomeoneElse?: boolean;
  contactDetails: ContactDetails;
  memberDetails?: Member;
}): ContactDetails =>
  isBookingForSomeoneElse
    ? mapMemberToContactDetails(memberDetails)
    : contactDetails;
